(() => {
  if (window.__arkanaCartDrawerV4Loaded) return;
  window.__arkanaCartDrawerV4Loaded = true;
  // Arkana Cart Drawer V4.8.1
  // Arkana Cart V4.7

  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  const getDrawer = () => qs('cart-drawer');
  const getError = () => qs('#CartDrawer-CartErrors');

  const EMPTY_RECOVERY_STORAGE_KEY = 'arkana-cart-empty-recovery-v1';
  let emptyRecoveryObserver = null;
  let observedRecoveryDrawer = null;
  let emptyRecoveryRenderTimer = null;

  function readEmptyRecoveryState() {
    try {
      const parsed = JSON.parse(window.sessionStorage.getItem(EMPTY_RECOVERY_STORAGE_KEY) || '{}');
      return {
        product: parsed?.product && parsed.product.variantId ? parsed.product : null,
        upsellHTML: typeof parsed?.upsellHTML === 'string' ? parsed.upsellHTML : ''
      };
    } catch (_) {
      return { product: null, upsellHTML: '' };
    }
  }

  let emptyRecoveryState = readEmptyRecoveryState();

  function saveEmptyRecoveryState() {
    try {
      window.sessionStorage.setItem(
        EMPTY_RECOVERY_STORAGE_KEY,
        JSON.stringify(emptyRecoveryState)
      );
    } catch (_) {}
  }

  function rememberCurrentUpsell() {
    const drawer = getDrawer();
    if (!drawer || drawer.classList.contains('is-empty')) return;

    const upsell =
      qs('.arkana-cart__upsell--mini:not(.arkana-cart__empty-recovery-panel)', drawer) ||
      qs('.arkana-cart__upsell:not(.arkana-cart__empty-recovery-panel)', drawer);

    if (!upsell) return;
    emptyRecoveryState.upsellHTML = upsell.outerHTML;
    saveEmptyRecoveryState();
  }

  function rememberRemovedProduct(row) {
    if (!row) return;

    const nameLink = qs('.arkana-cart__product-name', row);
    const image = qs('.arkana-cart__media img, img', row);
    const quantity = Math.max(Number(qs('.arkana-cart__qty-value', row)?.textContent || 1), 1);
    const variantId = String(row.dataset.arkanaVariantId || '').trim();
    if (!variantId) return;

    let accent = row.style.getPropertyValue('--blend-accent').trim();
    if (!accent) {
      try {
        accent = window.getComputedStyle(row).getPropertyValue('--blend-accent').trim();
      } catch (_) {}
    }

    emptyRecoveryState.product = {
      variantId,
      quantity,
      name: nameLink?.textContent?.trim() || 'Producto Arkana',
      objective: qs('.arkana-cart__objective', row)?.textContent?.trim() || '',
      price: qs('[data-arkana-line-price], .arkana-cart__price-current', row)?.textContent?.trim() || '',
      url: nameLink?.getAttribute('href') || '#',
      imageSrc: image?.currentSrc || image?.getAttribute('src') || '',
      imageAlt: image?.getAttribute('alt') || nameLink?.textContent?.trim() || 'Producto Arkana',
      accent: accent || '#CFEA68'
    };

    saveEmptyRecoveryState();
  }

  function createRecoveryCard(product) {
    const card = document.createElement('article');
    card.className = 'arkana-cart__upsell-mini-card arkana-cart__empty-restore-card';
    card.style.setProperty('--upsell-accent', product.accent || '#CFEA68');

    const accent = document.createElement('span');
    accent.className = 'arkana-cart__upsell-mini-accent';
    accent.setAttribute('aria-hidden', 'true');
    card.appendChild(accent);

    const imageLink = document.createElement('a');
    imageLink.className = 'arkana-cart__upsell-mini-image';
    imageLink.href = product.url || '#';
    imageLink.setAttribute('aria-label', product.name || 'Producto Arkana');
    if (product.imageSrc) {
      const image = document.createElement('img');
      image.src = product.imageSrc;
      image.alt = product.imageAlt || product.name || 'Producto Arkana';
      image.loading = 'lazy';
      imageLink.appendChild(image);
    }
    card.appendChild(imageLink);

    const body = document.createElement('div');
    body.className = 'arkana-cart__upsell-mini-body';

    const name = document.createElement('a');
    name.className = 'arkana-cart__upsell-mini-name';
    name.href = product.url || '#';
    name.textContent = product.name || 'Producto Arkana';
    body.appendChild(name);

    if (product.objective) {
      const benefit = document.createElement('span');
      benefit.className = 'arkana-cart__upsell-mini-benefit';
      benefit.textContent = product.objective;
      body.appendChild(benefit);
    }

    const meta = document.createElement('span');
    meta.className = 'arkana-cart__upsell-mini-price';
    meta.textContent = product.quantity > 1
      ? `Pack x${product.quantity}`
      : (product.price || '1 unidad');
    body.appendChild(meta);

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'arkana-cart__upsell-mini-button arkana-cart__empty-restore-button';
    button.dataset.arkanaAddUpsell = '';
    button.dataset.variantId = product.variantId;
    button.dataset.quantity = String(product.quantity || 1);
    button.textContent = product.quantity > 1 ? `+ Agregar x${product.quantity}` : '+ Agregar';
    button.setAttribute(
      'aria-label',
      `Volver a agregar ${product.name || 'producto'}${product.quantity > 1 ? ` x${product.quantity}` : ''}`
    );
    body.appendChild(button);

    card.appendChild(body);
    return card;
  }

  function createRecoveryPanel() {
    const panel = document.createElement('section');
    panel.className = 'arkana-cart__upsell arkana-cart__upsell--mini arkana-cart__empty-recovery-panel';

    const heading = document.createElement('p');
    heading.className = 'arkana-cart__section-eyebrow';
    heading.textContent = 'Volvé a agregarlo o elegí otro blend';
    panel.appendChild(heading);

    const grid = document.createElement('div');
    grid.className = 'arkana-cart__upsell-mini-grid is-static';
    grid.dataset.upsellCount = '0';
    panel.appendChild(grid);

    const error = document.createElement('p');
    error.className = 'arkana-cart__upsell-error';
    error.dataset.arkanaUpsellError = '';
    error.setAttribute('role', 'status');
    panel.appendChild(error);

    return panel;
  }

  function getCachedRecoveryPanel() {
    if (!emptyRecoveryState.upsellHTML) return createRecoveryPanel();

    const template = document.createElement('template');
    template.innerHTML = emptyRecoveryState.upsellHTML.trim();
    const panel = template.content.querySelector('.arkana-cart__upsell');
    if (!panel) return createRecoveryPanel();

    panel.classList.add('arkana-cart__empty-recovery-panel');
    panel.removeAttribute('id');
    qsa('[id]', panel).forEach((node) => node.removeAttribute('id'));
    qsa('[data-arkana-add-upsell]', panel).forEach((button) => {
      button.classList.remove('is-loading');
      button.disabled = false;
      if (button.textContent.trim() === 'Agregando…') button.textContent = '+ Agregar';
    });
    const error = qs('[data-arkana-upsell-error]', panel);
    if (error) error.textContent = '';
    return panel;
  }

  function renderEmptyRecovery() {
    const drawer = getDrawer();
    if (!drawer) return;

    if (!drawer.classList.contains('is-empty')) {
      rememberCurrentUpsell();
      return;
    }

    const empty = qs('.arkana-cart__empty, .cart-drawer__empty-content', drawer);
    if (!empty || qs('[data-arkana-empty-recovery]', empty)) return;

    const product = emptyRecoveryState.product;
    if (!product && !emptyRecoveryState.upsellHTML) return;

    const panel = getCachedRecoveryPanel();
    const grid = qs('.arkana-cart__upsell-mini-grid', panel);
    if (!grid) return;

    const alreadyPresent = product && qsa('[data-arkana-add-upsell]', grid).some(
      (button) => String(button.dataset.variantId || '') === String(product.variantId)
    );
    if (product && !alreadyPresent) grid.prepend(createRecoveryCard(product));

    const count = qsa('.arkana-cart__upsell-mini-card', grid).length;
    if (!count) return;
    grid.dataset.upsellCount = String(count);
    grid.classList.toggle('is-static', count <= 3);
    grid.classList.toggle('is-carousel', count > 3);

    const heading = qs('.arkana-cart__section-eyebrow', panel);
    if (heading) heading.textContent = 'Volvé a agregarlo o elegí otro blend';

    const wrapper = document.createElement('div');
    wrapper.className = 'arkana-cart__empty-recovery';
    wrapper.dataset.arkanaEmptyRecovery = '';
    wrapper.appendChild(panel);

    const exploreButton = qs('.arkana-cart__empty-button', empty);
    empty.insertBefore(wrapper, exploreButton || null);
    empty.classList.add('has-recovery');
  }

  function queueEmptyRecoveryRender() {
    window.clearTimeout(emptyRecoveryRenderTimer);
    emptyRecoveryRenderTimer = window.setTimeout(renderEmptyRecovery, 0);
  }

  function initEmptyRecovery() {
    const drawer = getDrawer();
    if (!drawer) return;

    if (drawer !== observedRecoveryDrawer) {
      emptyRecoveryObserver?.disconnect();
      observedRecoveryDrawer = drawer;
      emptyRecoveryObserver = new MutationObserver(queueEmptyRecoveryRender);
      emptyRecoveryObserver.observe(drawer, { childList: true, subtree: true });
    }

    rememberCurrentUpsell();
    queueEmptyRecoveryRender();
  }

  function setError(message = '') {
    const node = getError();
    if (node) node.textContent = message;
  }

  function formatMoney(cents, currency = 'ARS') {
    const value = Number(cents || 0) / 100;
    if (currency === 'ARS') {
      return `$${Math.round(value).toLocaleString('es-AR')}`;
    }
    try {
      return new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency,
        maximumFractionDigits: 2
      }).format(value);
    } catch (_) {
      return `$${value.toFixed(2)}`;
    }
  }

  function getConfig() {
    const drawer = getDrawer();
    return {
      tier1Qty: Number(drawer?.dataset.arkanaTier1Qty || 3),
      tier1Pct: Number(drawer?.dataset.arkanaTier1Pct || 10),
      tier2Qty: Number(drawer?.dataset.arkanaTier2Qty || 5),
      tier2Pct: Number(drawer?.dataset.arkanaTier2Pct || 15),
      tier3Qty: Number(drawer?.dataset.arkanaTier3Qty || 7),
      tier3Pct: Number(drawer?.dataset.arkanaTier3Pct || 20),
      shipQty: Number(drawer?.dataset.arkanaShipQty || 3),
      shipFee: Number(drawer?.dataset.arkanaShipFee || 1200000),
      installments: Math.max(Number(drawer?.dataset.arkanaInstallments || 3), 1)
    };
  }

  function discountPct(itemCount, cfg) {
    if (itemCount >= cfg.tier3Qty) return cfg.tier3Pct;
    if (itemCount >= cfg.tier2Qty) return cfg.tier2Pct;
    if (itemCount >= cfg.tier1Qty) return cfg.tier1Pct;
    return 0;
  }

  function rewardMessage(itemCount, cfg) {
    if (itemCount < cfg.tier1Qty) {
      const remaining = cfg.tier1Qty - itemCount;
      return `Sumá <strong>${remaining} ${remaining === 1 ? 'unidad' : 'unidades'}</strong> y desbloqueá <strong>ENVÍO GRATIS + ${cfg.tier1Pct}% OFF</strong>.`;
    }
    if (itemCount < cfg.tier2Qty) {
      const remaining = cfg.tier2Qty - itemCount;
      return `¡Tenés <strong>ENVÍO GRATIS + ${cfg.tier1Pct}% OFF</strong>! Sumá <strong>${remaining} ${remaining === 1 ? 'unidad' : 'unidades'}</strong> para llegar al <strong>${cfg.tier2Pct}% OFF</strong>.`;
    }
    if (itemCount < cfg.tier3Qty) {
      const remaining = cfg.tier3Qty - itemCount;
      return `¡Tenés <strong>ENVÍO GRATIS + ${cfg.tier2Pct}% OFF</strong>! Sumá <strong>${remaining} ${remaining === 1 ? 'unidad' : 'unidades'}</strong> para llegar al <strong>${cfg.tier3Pct}% OFF</strong>.`;
    }
    return `¡Desbloqueaste el máximo beneficio: <strong>ENVÍO GRATIS + ${cfg.tier3Pct}% OFF</strong>!`;
  }

  function updateMinusVisual(row, quantity) {
    const minus = qs('[data-arkana-qty-action="minus"]', row);
    if (!minus) return;
    const min = Math.max(Number(minus.dataset.min || 1), 1);
    const trash = quantity <= min;
    minus.classList.toggle('is-trash', trash);
    const productName = qs('.arkana-cart__product-name', row)?.textContent?.trim() || 'producto';
    minus.setAttribute('aria-label', trash ? `Eliminar ${productName}` : `Disminuir cantidad de ${productName}`);
  }

  function updateSelectionQuantity(line, quantity) {
    const selection = qs(`[data-arkana-selection-item="${line}"]`);
    const value = selection ? qs('[data-arkana-selection-qty]', selection) : null;
    if (value) value.textContent = String(quantity);
  }

  function setOptimisticQuantity(row, quantity) {
    const value = qs('.arkana-cart__qty-value', row);
    if (value) value.textContent = quantity;
    qsa('[data-arkana-qty-action]', row).forEach((button) => {
      button.dataset.quantity = String(quantity);
    });
    updateMinusVisual(row, quantity);
    const line = Number(row.dataset.arkanaLineIndex || 0);
    if (line) updateSelectionQuantity(line, quantity);
    row.classList.add('is-syncing');
  }

  function updateCartBubbleCount(count) {
    const bubble = qs('#cart-icon-bubble .cart-count-bubble');
    if (!bubble) return;
    const spans = qsa('span', bubble);
    if (spans[0]) spans[0].textContent = String(count);
    if (spans[1]) spans[1].textContent = `${count} ${count === 1 ? 'artículo' : 'artículos'}`;
  }

  function updateProgress(itemCount, cfg) {
    const fill = qs('.arkana-cart__progress-fill');
    if (fill) {
      const pct = cfg.tier3Qty > 0 ? Math.min((itemCount / cfg.tier3Qty) * 100, 100) : 0;
      fill.style.width = `${pct}%`;
    }

    const milestones = qsa('.arkana-cart__milestone');
    const thresholds = [cfg.tier1Qty, cfg.tier2Qty, cfg.tier3Qty];
    milestones.forEach((node, i) => node.classList.toggle('is-active', itemCount >= thresholds[i]));

    const message = qs('.arkana-cart__reward-message > div');
    if (message) message.innerHTML = rewardMessage(itemCount, cfg);
  }

  function applyCartState(state) {
    const drawer = getDrawer();
    if (!drawer || !state) return;

    const rows = qsa('.arkana-cart__item[data-arkana-line-index]');
    if (rows.length !== state.items.length) {
      refreshDrawerSections();
      return;
    }

    rows.forEach((row, index) => {
      const item = state.items[index];
      if (!item || Number(row.dataset.arkanaVariantId) !== Number(item.variant_id)) {
        refreshDrawerSections();
        return;
      }

      row.dataset.arkanaLineIndex = String(index + 1);
      qsa('[data-line-index]', row).forEach((node) => node.dataset.lineIndex = String(index + 1));

      const value = qs('.arkana-cart__qty-value', row);
      if (value) value.textContent = item.quantity;
      qsa('[data-arkana-qty-action]', row).forEach((button) => button.dataset.quantity = String(item.quantity));
      updateMinusVisual(row, item.quantity);
      updateSelectionQuantity(index + 1, item.quantity);

      const price = qs('[data-arkana-line-price]', row);
      const oldPrice = qs('[data-arkana-line-old-price]', row);
      if (price) price.textContent = formatMoney(item.final_line_price, state.currency);
      if (oldPrice) {
        oldPrice.textContent = formatMoney(item.original_line_price, state.currency);
        oldPrice.hidden = !(item.original_line_price > item.final_line_price);
      }
      row.classList.remove('is-syncing');
    });

    const cfg = getConfig();
    const shippingFree = state.item_count >= cfg.shipQty;
    const estimatedTotal = state.total_price + (shippingFree ? 0 : cfg.shipFee);
    const pct = discountPct(state.item_count, cfg);

    const count = qs('.arkana-cart__count');
    if (count) count.textContent = `(${state.item_count})`;
    updateCartBubbleCount(state.item_count);

    const subtotal = qs('[data-arkana-subtotal]');
    const discountRow = qs('[data-arkana-discount-row]');
    const discountLabel = qs('[data-arkana-discount-label]');
    const discount = qs('[data-arkana-discount]');
    const shipping = qs('[data-arkana-shipping]');
    const total = qs('[data-arkana-total]');
    const checkoutPrice = qs('[data-arkana-checkout-price]');
    const installment = qs('[data-arkana-installment]');
    const trustShipping = qs('[data-arkana-trust-shipping]');

    if (subtotal) subtotal.textContent = formatMoney(state.original_total_price, state.currency);
    if (discountRow) discountRow.hidden = !(state.total_discount > 0);
    if (discountLabel) discountLabel.textContent = pct > 0 ? `Descuento (${pct}% OFF)` : 'Descuento';
    if (discount) discount.textContent = `−${formatMoney(state.total_discount, state.currency)}`;
    if (shipping) shipping.textContent = shippingFree ? 'GRATIS' : formatMoney(cfg.shipFee, state.currency);
    if (total) total.textContent = formatMoney(estimatedTotal, state.currency);
    if (checkoutPrice) checkoutPrice.textContent = formatMoney(estimatedTotal, state.currency);
    if (installment) installment.textContent = formatMoney(Math.floor(estimatedTotal / cfg.installments), state.currency);
    if (trustShipping) {
      const freeText = trustShipping.dataset.freeText || 'Envío gratis';
      const paidText = trustShipping.dataset.paidText || 'Envíos a todo el país';
      trustShipping.textContent = shippingFree ? freeText : paidText;
    }

    updateProgress(state.item_count, cfg);
  }

  async function refreshDrawerSections() {
    try {
      const url = `${window.location.pathname}${window.location.pathname.includes('?') ? '&' : '?'}sections=cart-drawer,cart-icon-bubble`;
      const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const sections = await response.json();
      const drawer = getDrawer();
      if (!drawer || !sections?.['cart-drawer']) return window.location.reload();
      drawer.renderContents({ sections, id: null });
    } catch (error) {
      console.error('[Arkana Cart Refresh]', error);
      window.location.reload();
    }
  }

  async function postChange(line, quantity, fullRender = false) {
    const body = { line, quantity };
    if (fullRender) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(window.routes?.cart_change_url || `${window.Shopify?.routes?.root || '/'}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    });

    const state = await response.json();
    if (!response.ok || state?.errors) {
      throw new Error(state?.description || state?.message || state?.errors || 'No pudimos actualizar el carrito.');
    }
    return state;
  }

  const pending = new Map();
  let processing = false;
  let flushTimer = null;

  function scheduleQueue() {
    clearTimeout(flushTimer);
    flushTimer = setTimeout(processQueue, 110);
  }

  async function processQueue() {
    if (processing || pending.size === 0) return;
    processing = true;
    setError('');
    let finalState = null;

    try {
      while (pending.size > 0) {
        const [line, quantity] = pending.entries().next().value;
        pending.delete(line);

        if (quantity === 0) {
          finalState = await postChange(line, 0, true);
          const drawer = getDrawer();
          if (drawer && finalState.sections) drawer.renderContents(finalState);
          pending.clear();
          return;
        }

        finalState = await postChange(line, quantity, false);
      }

      if (finalState) applyCartState(finalState);
    } catch (error) {
      console.error('[Arkana Cart Quantity]', error);
      setError(error.message || 'No pudimos actualizar el carrito.');
      qsa('.arkana-cart__item.is-syncing').forEach((row) => row.classList.remove('is-syncing'));
      refreshDrawerSections();
    } finally {
      processing = false;
      if (pending.size > 0) scheduleQueue();
    }
  }

  document.addEventListener('click', (event) => {
    const qtyButton = event.target.closest('[data-arkana-qty-action]');
    const removeButton = event.target.closest('[data-arkana-remove]');
    if (!qtyButton && !removeButton) return;

    event.preventDefault();
    event.stopPropagation();

    const source = qtyButton || removeButton;
    const row = source.closest('.arkana-cart__item');
    const line = Number(source.dataset.lineIndex || row?.dataset.arkanaLineIndex || 0);
    if (!row || !line) return;

    let nextQuantity = 0;

    if (qtyButton) {
      const current = Number(qs('.arkana-cart__qty-value', row)?.textContent || qtyButton.dataset.quantity || 0);
      const step = Math.max(Number(qtyButton.dataset.step || 1), 1);
      const min = Math.max(Number(qtyButton.dataset.min || 1), 1);
      const maxRaw = Number(qtyButton.dataset.max);
      const max = Number.isFinite(maxRaw) && maxRaw > 0 ? maxRaw : null;

      if (qtyButton.dataset.arkanaQtyAction === 'plus') {
        nextQuantity = current + step;
        if (max !== null) nextQuantity = Math.min(nextQuantity, max);
      } else {
        nextQuantity = current <= min ? 0 : Math.max(current - step, min);
      }

      if (nextQuantity === current) return;

      if (nextQuantity > 0) {
        setOptimisticQuantity(row, nextQuantity);
      } else {
        row.classList.add('is-syncing');
      }
    } else {
      row.classList.add('is-syncing');
    }

    if (nextQuantity === 0) {
      rememberCurrentUpsell();
      rememberRemovedProduct(row);
    }

    pending.set(line, nextQuantity);
    scheduleQueue();
  }, true);

  /* CROSS-SELL: add + full drawer refresh because the recommendation set changes. */
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-arkana-add-upsell]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    if (button.classList.contains('is-loading')) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;
    const quantity = Math.max(Number(button.dataset.quantity || 1), 1);

    const originalText = button.textContent;
    button.classList.add('is-loading');
    button.disabled = true;
    button.textContent = 'Agregando…';

    try {
      const formData = new FormData();
      formData.append('items[0][id]', variantId);
      formData.append('items[0][quantity]', String(quantity));
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);

      const response = await fetch(window.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const state = await response.json();
      if (!response.ok || state?.status) throw new Error(state?.description || state?.message || 'No pudimos agregar este producto.');

      const drawer = getDrawer();
      drawer?.classList.remove('is-empty');
      if (drawer && state.sections) drawer.renderContents(state);
      else window.location.reload();
    } catch (error) {
      console.error('[Arkana Cart Upsell]', error);
      const errorNode = qs('[data-arkana-upsell-error]');
      if (errorNode) errorNode.textContent = error.message || 'No pudimos agregar el producto.';
      button.classList.remove('is-loading');
      button.disabled = false;
      button.textContent = originalText;
    }
  }, true);

  /* DAILY COUNTDOWN */
  const isWeekend = (date) => [0, 6].includes(date.getDay());

  function addBusinessDays(date, amount) {
    const result = new Date(date);
    let added = 0;
    while (added < amount) {
      result.setDate(result.getDate() + 1);
      if (!isWeekend(result)) added++;
    }
    return result;
  }

  function getNextDailyCutoff(now, hour, minute) {
    const cutoff = new Date(now);
    cutoff.setHours(hour, minute, 0, 0);
    if (now >= cutoff) {
      cutoff.setDate(cutoff.getDate() + 1);
      cutoff.setHours(hour, minute, 0, 0);
    }
    return cutoff;
  }

  function formatRemaining(ms) {
    const totalSeconds = Math.max(Math.floor(ms / 1000), 0);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${hours}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
  }

  function formatDeliveryDate(date) {
    const weekdays = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
    const months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    return `${weekdays[date.getDay()]}, ${date.getDate()} ${months[date.getMonth()]}`;
  }

  function updateDeliveryClaim() {
    qsa('[data-arkana-delivery]').forEach((node) => {
      const now = new Date();
      const hour = Math.min(Math.max(Number(node.dataset.cutoffHour || 0), 0), 23);
      const minute = Math.min(Math.max(Number(node.dataset.cutoffMinute || 0), 0), 59);
      const minDays = Math.max(Number(node.dataset.deliveryMin || 1), 1);
      const maxDays = Math.max(Number(node.dataset.deliveryMax || minDays), minDays);

      const cutoff = getNextDailyCutoff(now, hour, minute);
      const countdown = qs('[data-arkana-countdown]', node);
      const range = qs('[data-arkana-delivery-range]', node);
      if (countdown) countdown.textContent = formatRemaining(cutoff.getTime() - now.getTime());

      const todayCutoff = new Date(now);
      todayCutoff.setHours(hour, minute, 0, 0);
      const anchor = now < todayCutoff ? new Date(now) : new Date(cutoff);
      const earliest = addBusinessDays(anchor, minDays);
      const latest = addBusinessDays(anchor, maxDays);

      if (range) {
        const sameDay = earliest.toDateString() === latest.toDateString();
        range.textContent = sameDay ? formatDeliveryDate(earliest) : `${formatDeliveryDate(earliest)} y ${formatDeliveryDate(latest)}`;
      }
    });
  }

  updateDeliveryClaim();
  window.setInterval(updateDeliveryClaim, 1000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEmptyRecovery, { once: true });
  } else {
    initEmptyRecovery();
  }
  document.addEventListener('shopify:section:load', initEmptyRecovery);
})();
